import { Desktop } from "../../api/models";

export let DesktopEnumDisplay: { [index: number]: string } = {};
DesktopEnumDisplay[Desktop.ErshadDesktop] = "enums.Desktop.MainDesktop";
DesktopEnumDisplay[Desktop.ElectionDesktop] = "enums.Desktop.OrangeDesktop";
DesktopEnumDisplay[Desktop.Default] = "enums.Desktop.Default";
